import { render, staticRenderFns } from "./DaysVDistributionList.vue?vue&type=template&id=720ffc1c&"
import script from "./DaysVDistributionList.vue?vue&type=script&lang=js&"
export * from "./DaysVDistributionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports